"use strict";
require("./..\\..\\..\\bower_components\\magnific-popup\\dist\\jquery.magnific-popup.js");

module.exports = function () {
	
	$('.popup-link').magnificPopup({
		type: 'inline',
		preloader: false,
		removalDelay: 150,
		showCloseBtn: false
	});

	$(document).on('click', '.popup__close', function(e) {
		$.magnificPopup.close();
		e.preventDefault();
	});

};